import React from 'react'

export default function ErrorPage() {
    return (
        <div className='dark:bg-gray-800' style={{ textAlign: "center", color: "red", fontSize: "72px", paddingTop: "100px"}}>
            <h1>Error Page</h1>
            <h3>404</h3>
        </div>
    )
}
